import { AlertRuleDataGridRow } from '../components/AlertRuleDataGrid'
import { AlertGroup, AlertSensor } from '../types/Alerts'
import { makeAlertRuleDataGridRow } from '../utils/alert'

export interface EnabledAlertRules {
  enabledAlertRules: AlertRuleDataGridRow[]
  enabledProjectAlertRules: AlertRuleDataGridRow[]
  enabledDeviceAlertRules: AlertRuleDataGridRow[]
  eanbledValveAlertRules: AlertRuleDataGridRow[]
  enabledRuuviTagAlertRules: AlertRuleDataGridRow[]
}

export default function useEnabledAlertRules(alertRules: AlertGroup[]): EnabledAlertRules {
  /**
   * The enabled alerts.
   */
  const enabledAlertRules = alertRules
    .map((group) =>
      group.alerts
        .filter((rule) => rule.enabled)
        .map((rule) => makeAlertRuleDataGridRow(group, rule))
    )
    .flat()

  /**
   * The enabled project alerts.
   */
  const enabledProjectAlertRules = enabledAlertRules.filter((row) => row.sensor === undefined)

  /**
   * The enabled device alert rules.
   */
  const enabledDeviceAlertRules = enabledAlertRules.filter(
    (row) => row.sensor === AlertSensor.DEVICE
  )

  /**
   * The enabled valve alert rules.
   */
  const eanbledValveAlertRules = enabledAlertRules.filter((row) => row.sensor === AlertSensor.VALVE)

  /**
   * The enabled ruuvitag alert rules.
   */
  const enabledRuuviTagAlertRules = enabledAlertRules.filter(
    (row) => row.sensor === AlertSensor.RUUVITAG
  )

  return {
    enabledAlertRules,
    enabledProjectAlertRules,
    enabledDeviceAlertRules,
    eanbledValveAlertRules,
    enabledRuuviTagAlertRules
  }
}
